export const forcedThemeRules = (pathname?: string | null) => {
  let forcedTheme: "light" | "dark" | undefined = undefined;

  if (
    pathname === "/" ||
    pathname === "/ro" ||
    pathname === "/en" ||
    pathname === "/es" ||
    pathname?.startsWith("/uat") ||
    pathname?.includes("/login") ||
    pathname?.includes("/doc/")
  ) {
    forcedTheme = "light";
  }

  return forcedTheme;
};
